import Bacon from "Bacon";
import translate from "translate";
import Hogan from "hogan";

var templates = {};

// Monkey-patch hogan rendering to include our mustache translator function
const hoganRenderer = Hogan.Template.prototype.render;
Hogan.Template.prototype.render = function (context, partials, indent) {
  const contextWithIntl = {
    intl: () => translate,
    ...context,
  };
  return hoganRenderer.call(this, contextWithIntl, partials, indent);
};

function getTemplate(cache, name) {
  if (cache[name] === undefined) {
    setTemplate(name, require("web/views/" + name + ".mustache"));
  }
  return cache[name];
}

function noTemplate() {
  return Bacon.constant(true);
}

function getTemplates(cache, content) {
  if (Array.isArray(content)) {
    return Bacon.combineAsArray(content.map(getTemplate.bind(null, cache)));
  } else if (content !== undefined) {
    return getTemplate(cache, content);
  } else {
    return noTemplate();
  }
}

function setTemplate(name, stream) {
  templates[name] = Bacon.constant(stream);
}

export default {
  render: function (template, data, partials) {
    return template.render(data, partials);
  },
  get: getTemplates.bind(null, templates),
  set: setTemplate.bind(null, templates),
};



// WEBPACK FOOTER //
// ./web/js/template.js